import LayoutV2 from "containers/LayoutV2";
import SearchForm from "./SearchForm";
import PaginationSection from "../QuanTriHeThong/QuanLyMauThuChi/PaginationSection";
import QuyKhacTable from "./QuyKhacTable";
import React, { useEffect, useState, useCallback } from "react";
import UserApi from "service/userApi";
import "react-dropdown/style.css";
import DanhSachQuyKhacApi from "service/DanhSachQuyKhacApi";
import { formatDayMonth } from "utils/formatDate";
import MenuChucNang from "./MenuChucNang";
import NhapRutQuy from "./ChucNang/NhapRutQuy";
import { getUserLogin } from "utils/user";
import XoaQuyKhac from "./ChucNang/XoaQuy";
import { pushNotification } from "utils/notifications";

const DanhSachQuyKhac = () => {

    const [listUserName, setListUserName] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dataResponse, setdataResponse] = useState([]);
    const [modalType, setModalType] = useState(null);
    const closeModal = () => setModalType(null);


    const [hasPermission, setHasPermission] = useState(null);
    const [RoleNhapQuy, setRoleNhapQuy] = useState(null);
    const [RoleRutQuy, setRoleRutQuy] = useState(null);
    const [RoleSuaQuy, setRoleSuaQuy] = useState(null);
    const [RoleXoaQuy, setRoleXoaQuy] = useState(null);
    const [KhongSuDungDuyetQuy, setKhongSuDungDuyetQuy] = useState(null);


    const [editingItem, setEditingItem] = useState(null);
    const [deleteItem, setDeleteItem] = useState(null);
    const [showXoaQuy, setShowXoaQuy] = useState(false);

    const [UserName, setUserName] = useState("");


    useEffect(() => {
        document.title = "Quản lý quỹ khác | Phần mềm quản lý cầm đồ Morman";
        fetchPermission();
        loadDanhSachUserName();
    }, []);

    const fetchPermission = async () => {
        try {
            const res = await UserApi.getAllQuyen();
            const roles = res.data.map((item) => item.ModuleCode.toLowerCase());
            setHasPermission(roles.includes("quanlyquykhac"));
            setRoleNhapQuy(roles.includes("quanlyquykhac_nhapquy"));
            setRoleRutQuy(roles.includes("quanlyquykhac_rutquy"));
            setRoleSuaQuy(roles.includes("quanlyquykhac_suaquy"));
            setRoleXoaQuy(roles.includes("quanlyquykhac_xoaquy"));
            setKhongSuDungDuyetQuy(roles.includes("quanlyquykhac_khongsudungduyetquy"));
        } catch (err) {
            console.error("Lỗi load quyền:", err);
            setHasPermission(false);
            setRoleNhapQuy(false);
            setRoleRutQuy(false);
            setKhongSuDungDuyetQuy(false);
        }
        var username
        try {
            username = getUserLogin().UserName;
        }
        catch {
            username = "test";
        }
        setUserName(username);
    };
    const [dataSearch, setDataSearch] = useState({
        sCode: "",
        sFromDate: null,
        sToDate: null,
        sType: "",
        sUserName: "",
        pageIndex: 1,
        pageSize: 20,
    });

    const loadDanhSachQuyKhac = useCallback(async (searchData, page) => {
        try {
            setLoading(true);
            const payload = {
                ...searchData,
                sFromDate: searchData.sFromDate
                    ? formatDayMonth(searchData.sFromDate)
                    : undefined,
                sToDate: searchData.sToDate
                    ? formatDayMonth(searchData.sToDate)
                    : undefined,
                pageIndex: page,
            };
            const res = await DanhSachQuyKhacApi.list(payload);

            const listData = res.data || [];

            setdataResponse(listData);
            setDataSearch((prev) => ({ ...prev, pageIndex: page }));

            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        } catch (error) {
            console.error("Lỗi load danh sách quỹ khác:", error);
        } finally {
            setLoading(false);
        }
    }, []);
    const loadDanhSachUserName = useCallback(async () => {
        try {

            const res = await UserApi.getAllUserName();

            setListUserName(res.data || []);
        } catch (error) {
            console.error("Lỗi load danh sách user name:", error);
        }
    }, []);

    useEffect(() => {
        if (hasPermission) {
            loadDanhSachQuyKhac(dataSearch, 1);
        }
    }, [hasPermission]);


    const onChangeData = (field) => (event) => {
        const value = event?.target?.value ?? "";
        setDataSearch((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const onChangeDate = (field) => (value) => {
        setDataSearch((prev) => ({
            ...prev,
            [field]: value,
        }));
    };
    const handlePageChange = (pageNumber) => {
        loadDanhSachQuyKhac(dataSearch, pageNumber)
    };

    const onSearch = () => {
        loadDanhSachQuyKhac(dataSearch, 1)
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            loadDanhSachQuyKhac(dataSearch, 1)
        }
    };

    const btnNhapQuyClick = () => {
        setEditingItem({
            ThuChiId: 0,
            Type: 51,
            Time: "",
            UserName: UserName,
            Value: 0,
            Note: "",
            AdminApprove: KhongSuDungDuyetQuy ? 1 : 0,
            Status: KhongSuDungDuyetQuy ? 1 : -1
        });
        setModalType("nhap");
    }
    const btnRutQuyClick = () => {
        setEditingItem({
            ThuChiId: 0,
            Type: 52,
            Time: "",
            UserName: UserName,
            Value: 0,
            Note: "",
            AdminApprove: KhongSuDungDuyetQuy ? 1 : 0,
            Status: KhongSuDungDuyetQuy ? 1 : -1
        });
        setModalType("rut");
    };

    const btnSuaQuyClick = (data) => {
        setEditingItem(data);
        setModalType("sua");
    }
    const btnXoaQuyClick = (ThuChiId) => {
        setDeleteItem(ThuChiId);
        setShowXoaQuy(true);
    }

    if (hasPermission === false) {
        return (
            <LayoutV2>
                <h2 className="text-danger">
                    <div className="custom-table-row">
                        <div
                            className="custom-table-cell text-center red"
                            style={{ width: "100%" }}
                        >
                            Bạn không có quyền truy cập trang này!
                        </div>
                    </div>
                </h2>
            </LayoutV2>
        );
    }
    return (
        <LayoutV2>
            <div id="form-repeater">
                <div className="sticky-moman-bh">
                    <div className="col-12">
                        <div className="camdo-home">
                            <div className="breadcrumb-new">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 title-cd">
                                        <div className="media-home align-center-home">
                                            <div className="row header">
                                                <img
                                                    src="/app-assets/images/icon-hop-dong-cho-duyet.png"
                                                    alt="logo"
                                                />
                                                <h1 className="text-info-home">Quản lý quỹ khác</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="card border-light mb-3 hidden-mobile-main show-table-main card-v2"
                                style={{}}
                            >
                                <div className="card-body card-body-v2">
                                    <SearchForm
                                        listUserName={listUserName}
                                        dataSearch={dataSearch}
                                        onChangeData={onChangeData}
                                        onChangeDate={onChangeDate}
                                        onSearch={onSearch}
                                        handleKeyDown={handleKeyDown}
                                    />
                                </div>
                            </div>
                            {loading && (<>
                                <div className="loader loader-default is-active"></div>
                            </>)}
                            <div
                                className="card border-light mb-3 hidden-mobile-main show-table-main card-v2"
                                style={{ display: (RoleNhapQuy || RoleRutQuy) ? "block" : "none", marginTop: "-35px", maxHeight: "54px" }}
                            >
                                <div className="card-body card-body-v2">
                                    <MenuChucNang
                                        RoleNhapQuy={RoleNhapQuy}
                                        RoleRutQuy={RoleRutQuy}
                                        btnNhapQuyClick={btnNhapQuyClick}
                                        btnRutQuyClick={btnRutQuyClick}
                                    />
                                </div>
                            </div>
                            {!loading && (<>
                                <div
                                    className="card border-light mb-3 card-v2"
                                    style={{ marginTop: "-35px" }}
                                >
                                    <div className="card-body card-body-v2" style={{ userSelect: "text" }}>

                                        <QuyKhacTable
                                            list={dataResponse}
                                            pageIndex={dataSearch.pageIndex}
                                            pageSize={dataSearch.pageSize}
                                            btnSuaQuyClick={btnSuaQuyClick}
                                            btnXoaQuyClick={btnXoaQuyClick}
                                            RoleSuaQuy={RoleSuaQuy}
                                            RoleXoaQuy={RoleXoaQuy}
                                        />
                                    </div>
                                    <div
                                        className="card border-light mb-3 card-v2"
                                        style={{
                                            marginLeft: "15px",
                                            marginRight: "15px",
                                            marginTop: "15px",
                                        }}
                                    >
                                        <div
                                            className="card-body card-body-v2"
                                            style={{ display: dataResponse.iTotal === 0 ? "none" : "block" }}
                                        >
                                            <PaginationSection
                                                iTotal={dataResponse.iTotal}
                                                dataSearch={dataSearch}
                                                handlePageChange={handlePageChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>)}
                        </div>
                    </div>
                </div>
                {modalType && (
                    <NhapRutQuy
                        onClose={closeModal}
                        loadDanhSachQuyKhac={()=>loadDanhSachQuyKhac(dataSearch,1)}
                        title={
                            modalType === "nhap" ? "Nhập quỹ" :
                                modalType === "rut" ? "Rút quỹ" :
                                    "Sửa quỹ"
                        }
                        data={editingItem}
                    />
                )}
                {showXoaQuy && (<XoaQuyKhac
                    ThuChiId={deleteItem}
                    onClose={() => setShowXoaQuy(false)}
                    loadDanhSachQuyKhac={()=>loadDanhSachQuyKhac(dataSearch,1)}
                />)}
            </div>
        </LayoutV2 >
    );
}

export default DanhSachQuyKhac;